// 📊 Version Progress Route
import { createFileRoute } from '@tanstack/react-router';

import { VersionProgressPage } from '@/features/versions/pages';

export const Route = createFileRoute('/_authenticated/_withWorkspace/versions/progress')({
  component: VersionProgressPage,
  validateSearch: (search: Record<string, unknown>) => ({
    versionId: (search.versionId as string) || undefined,
  }),
});
